import { TkticSelect } from "@/components/ui/TkticSelect";

/** Single-select control used for manual coaching defaults. */
type ChoiceOption = { value: string; label: string };

export type SettingChipGroupProps = {
  label: string;
  description?: string;
  options: ReadonlyArray<ChoiceOption>;
  value: string;
  disabled?: boolean;
  onChange: (next: string) => void;
  "data-testid"?: string;
};

export function SettingChipGroup({
  label,
  description,
  options,
  value,
  disabled,
  onChange,
  "data-testid": testid,
}: SettingChipGroupProps) {
  return (
    <div data-testid={testid} className="setting-select">
      <div className="text-sm font-display text-ink">{label}</div>
      {description ? (
        <p className="text-ink-muted text-xs mt-0.5 mb-1.5">{description}</p>
      ) : null}
      <TkticSelect
        ariaLabel={label}
        options={[...options]}
        value={value}
        disabled={disabled}
        onChange={onChange}
      />
    </div>
  );
}
